import handler from 'api/handler'

const prefix = '/public/businessReview'

const methods = {
  create: args => handler({ method: 'post', url: prefix + '/create', args }),
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  update: args => handler({ method: 'put', url: prefix + '/update', args }),
  delete: args => handler({ method: 'delete', url: prefix + '/delete', args }),
  fetchUserReview: args => handler({ method: 'get', url: prefix + '/fetchUserReview', args })
}

export default methods

